import { render, staticRenderFns } from "./orders-pdf.vue?vue&type=template&id=3200daa9&scoped=true&"
import script from "./orders-pdf.vue?vue&type=script&lang=ts&"
export * from "./orders-pdf.vue?vue&type=script&lang=ts&"
import style0 from "./orders-pdf.vue?vue&type=style&index=0&id=3200daa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200daa9",
  null
  
)

export default component.exports